import { useContext } from "react";
import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";
import { ETab, TabContext, TabProvider } from "components/pages/ProfessionalSpace/tabs/Casting/contexts/Tab";
import { ProjectTeamProvider } from "components/pages/ProfessionalSpace/contexts/ProjectTeam";
import { CastingList } from "./CastingList";
import CastingForum from "./CastingForum";
import CastingVote from "./CastingVote";
import Tabs from "./Tabs";
import classes from "./classes.module.scss";

function CastingContent() {
	const { isActiveTab } = useContext(TabContext);

	return (
		<div className={classes["root"]}>
			<Typography type="h3" weight="bold" className={classes["title"]}>
				{I18n.asset.pages.professional_space.tabs.casting.title}
			</Typography>

			<div className={classes["tabs-container"]}>
				<Tabs />
			</div>

			{isActiveTab(ETab.FORUM) && <CastingForum />}
			{isActiveTab(ETab.VOTE) && <CastingVote />}
			{isActiveTab(ETab.CASTING) && <CastingList />}
		</div>
	);
}

export default function Casting() {
	return (
		<ProjectTeamProvider>
			<TabProvider defaultTab={ETab.FORUM}>
				<CastingContent />
			</TabProvider>
		</ProjectTeamProvider>
	);
}
